import styled from 'styled-components';
import { IButton, ISubtitle } from './interface';

const base = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem 0 0.5rem;
  background-color: ${(props) => props.theme.colors.header};
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
  width: 100%;
`;

const button = styled.div<IButton>`
  color: #909090;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 2rem;
  cursor: ${(props) => (props.children ? 'pointer' : '')};
`;

const title = styled.h1`
  font-size: ${(props) => props.theme.fontSize.big};
  color: ${(props) => props.theme.colors.mainColor};
`;

const subtitle = styled.h2<ISubtitle>`
  display: ${(props) => (props.isShowed ? 'flex' : 'none')};
  color: ${(props) => props.theme.colors.lightGray};
  font-size: ${(props) => props.theme.fontSize.medium};
`;

const Header = {
  Base: base,
  Button: button,
  Title: title,
  Subtitle: subtitle,
};

export default Header;
